import { Action } from "@reduxjs/toolkit";
import { AppState } from "./types";
import { isType } from "typescript-fsa";
import { appActions } from "./actions";

const initialState: AppState = {
  isLoading: false,
  showModal: false,
  modalObject: {
    title: "",
    subTitle: "",
    buttons: [],
  },
  showSessionExpiredModal: false,
};

export function AppReducer(state = initialState, action: Action): AppState {
  if (isType(action, appActions.init.done)) {
    return {
      ...state,
    };
  }

  if (isType(action, appActions.showLoading)) {
    return {
      ...state,
      isLoading: true,
    };
  }

  if (isType(action, appActions.hideLoading)) {
    return {
      ...state,
      isLoading: false,
    };
  }

  if (isType(action, appActions.showModal)) {
    return {
      ...state,
      showModal: true,
      modalObject: action.payload,
    };
  }

  if (isType(action, appActions.hideModal)) {
    return {
      ...state,
      showModal: false,
      modalObject: {
        title: "",
        subTitle: "",
        buttons: [],
      },
    };
  }

  if (isType(action, appActions.showSessionExpiredModal)) {
    return {
      ...state,
      showSessionExpiredModal: true,
    };
  }

  if (isType(action, appActions.hideSessionExpiredModal)) {
    // Reset the modal flag when modal is hidden
    if (typeof window !== 'undefined') {
      const { resetSessionExpiredModalFlag } = require('../../core/http/httpClient');
      resetSessionExpiredModalFlag();
    }

    return {
      ...state,
      showSessionExpiredModal: false,
    };
  }

  if (isType(action, appActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
